<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('B0400.titles[5]')}}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn @click="submit">{{$t('app.buttons.add')}}</v-btn>
        <v-btn @click="show = false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field :label="$t('app.labels.poNo')" clearable v-model="query.poNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field :label="$t('app.labels.ivNo')" clearable v-model="query.invoiceNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kv?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected[pagination.page]"
      >
        <template slot="items" slot-scope="props">
          <td width="20">
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.loadingPortName }}</td>
          <td>{{ props.item.dischargePortName }}</td>
          <td>{{ props.item.partnerCode + ":" + props.item.partnerName }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['sa'],
  data() {
    return {
      show: false,
      query: { poNo: null, invoiceNo: null },
      resolve: null,
      reject: null,
      selected: {},
      results: [],
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      headers: [
        {
          text: this.$t('app.labels.ivNo'),
          value: 'invoiceNo'
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPortName'
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePortName'
        },
        {
          text: this.$t('app.labels.partner'),
          value: 'partner'
        }
      ]
    }
  },
  methods: {
    search() {
      this.pagination.page = 1
      this.load()
    },
    setData(res) {
      this.pagination.page = res.data.number + 1
      this.pagination.rowsPerPage = res.data.size
      this.pagination.totalItems = res.data.totalElements
      this.results = res.data.content
      this.loading = false
      this.selected = []
    },

    load() {
      this.autoload = true
      if (this.sa.shipmentType === 'FORMALSA') {
        this.$http
          .get('commercial-invoices/unused-unpaid-invoice', {
            params: { ...this.query, ...this.$pageable() }
          })
          .then(res => {
            this.setData(res)
          })
      } else {
        this.$http
          .get('commercial-invoices/unused-invoice', {
            params: { ...this.query, ...this.$pageable() }
          })
          .then(res => {
            this.setData(res)
          })
      }
    },
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      // if (this.hasDifBu()) {
      //   this.$message('', this.$t('B0400.messages.errors.inv_bu_unique')) //'Invoiceに複数事業本部のPOが入れられません'
      // } else
      var arr = [].concat(...Object.values(this.selected))
      console.log(arr)
      let invoiceIds = [...new Set(arr.map(s => s.id))]
      Promise.all(
        invoiceIds.map(id => {
          return this.$http.get(`/commercial-invoices/${id}`).then(res => {
            return res.data
          })
        })
      ).then(invoices => {
        this.resolve(invoices)
        this.selected = {}
        this.show = false
      })
    },
    hasDifBu() {
      var arr = [].concat(...Object.values(this.selected))
      var a = []
      arr.forEach(s => {
        a = [...a, ...s.packages]
      })
      a = [...a, ...this.sa.packages]
      var b = a
        .filter(p => p.buHeadquartersId != null)
        .map(p => p.buHeadquartersId)
        .reduce((t, b) => {
          if (t.indexOf(b) == -1) {
            t.push(b)
          }
          return t
        }, [])
      if (b.length > 1) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
